import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-volvo",
  "use": "icon-ic-list-volvo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-volvo\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm2-14v1.42h1.3a.12.12 0 0 1 .12.12l-2.22 4.1-2.36-4a.17.17 0 0 1 .16-.22h1.43V8H4.5v1.42h1.64c.05.002.096.024.13.06L10 16h4.33l3.5-6.54a.285.285 0 0 1 .13 0h1.54V8H14z\" fill=\"#323336\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol